import React, { Component } from 'react'
import { AuthContext } from 'contexts'
import { gql } from 'apollo-boost'
import { Query, Mutation } from 'react-apollo'
import styled from 'styled-components'
import * as speech from 'speech'
import { Link } from 'react-router-dom'

import { Icon, Navbar, NavbarItem, NavbarEnd, NavbarBrand, NavbarBurger, NavbarMenu, NavbarDropdown, NavbarLink, NavbarDivider } from 'bloomer'

const GET_ME = gql`
  {
    me {
      id, username, firstName, lastName, houses { id, name }
    }
  }
`

const GET_RESPONSE_FROM_DIALOGFLOW = gql`
  mutation getRespondeFromDialogflow($message: String!) {
    getResponseFromDialogflow(message: $message) {
      response { fulfillment, parameters { module, command }, actionIncomplete }
    }
  }
`

const NavbarCenter = styled(NavbarEnd)`
  justify-content: center;
`


export default class Header extends Component {

  state = {
    isActive: false,
    isVoiceRecognitionInProgress: false,
  }

  toggleMenu = () => {
    this.setState(({isActive}) => ({
      isActive: !isActive
    }))
  }

  handleVoiceRecognition = (getRespondeFromDialogflow, evt) => {
    evt.preventDefault()

    this.setState(() => ({isVoiceRecognitionInProgress: true}))
    speech.recognition(async (message) => {

      try {
        const result = await getRespondeFromDialogflow({
          variables: {message}
        })

        const { actionIncomplete, parameters, fulfillment } = result.data.getResponseFromDialogflow.response

        if (!actionIncomplete) {
          const eventCommand = new CustomEvent(`command:${parameters.module}`, { detail: parameters.command })
          document.dispatchEvent(eventCommand)
        }

        speech.speak(fulfillment)
      } catch (e) {
        speech.speak("Alguma coisa deu errado! Não consegui me conectar!")
      }

      this.setState(() => ({isVoiceRecognitionInProgress: false}))
    })
  }

  render() {
    const {
      isActive,
      isVoiceRecognitionInProgress,
    } = this.state

    const { title: renderTitle } = this.props

    return (
      <Navbar className="is-primary">
        <NavbarBrand>
          <NavbarItem style={{textTransform: 'uppercase'}} render={(props) => <Link {...props} to="/dashboard">Luna</Link>}/>
          <Mutation mutation={GET_RESPONSE_FROM_DIALOGFLOW}>
            {(getResponseFromDialogflow, {loading}) => (
              <NavbarItem href="#" isActive={isVoiceRecognitionInProgress} onClick={this.handleVoiceRecognition.bind(this, getResponseFromDialogflow)}>
                <Icon className="fa fa-microphone" />
              </NavbarItem>
            )}
          </Mutation>
          <NavbarBurger isActive={isActive} onClick={this.toggleMenu} />
        </NavbarBrand>
        <NavbarMenu isActive={isActive} onClick={this.toggleMenu}>
          <AuthContext.Consumer>
            {({logoutHandler}) => <Query query={GET_ME}>
              {({loading, error, data}) => {
                if (loading || error) {
                  return null
                }

                const { me: user } = data

                return (
                  <React.Fragment>
                    <NavbarCenter>{renderTitle()}</NavbarCenter>
                    <NavbarEnd>
                      <NavbarItem hasDropdown isHoverable>
                        <NavbarLink style={{textTransform: 'uppercase'}}>{user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : `@${user.username}`}</NavbarLink>
                        <NavbarDropdown>
                          <NavbarItem render={(props) => <Link to="/settings" {...props}>Configurações</Link>}/>
                          <NavbarDivider />
                          <NavbarItem href="logout" onClick={(evt) => {evt.preventDefault(); logoutHandler()}}>Sair</NavbarItem>
                        </NavbarDropdown>
                      </NavbarItem>
                    </NavbarEnd>
                  </React.Fragment>
                )
              }}
            </Query>}
          </AuthContext.Consumer>
        </NavbarMenu>
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js